import TextField from '@mui/material/TextField';

const FromTextField = ({
  onChange = (event: any) => { onChange(event); }
}) => (
  <TextField id="tfgenpinno"
    label="依頼番号"
    size="small"
    inputProps={{ maxLength: 8 }}
    onChange={(event: any) => { onChange(event); }}
  />
);

export default FromTextField;